<template>
    <div>
        <div class="container">
            <div class="row mt-5">
                <div class="col-12 text-center my-5">
                    <h3 class="heading">Associations</h3>
                <hr class="custom-hr">
                </div>
            </div>
            <div class="row">
                <div class="col-12 my-5">
                    <carousel :nav="false" :autoplay="true"  :dots="false" :autoWidth="true" :loop="true"  :margin="40" :center="true" :stagePadding="200" :responsive="{0:{items:1,nav:false},700:{items:1,nav:false}}">
                        <div class="association">
                            <img src="../assets/images/associates/18 Degrees Festival Shillong-2014.jpg" alt="">
                            <h3 class="text-center"> 18 Degrees Festival Shillong-2014</h3>
                        </div>
                        <div class="association">
                            <img src="../assets/images/associates/Assam Tourism National Photography Exhibition.jpg" alt="">
                            <h3 class="text-center">Assam Tourism National Photography Exhibition</h3>
                        </div>
                        <div class="association">
                            <img src="../assets/images/associates/CHILD LABOUR.jpg" alt="">
                            <h3 class="text-center">World Day Agiainst Child Labour 2018</h3>
                        </div>
                        <div class="association">
                            <img src="../assets/images/associates/South Asian Games.jpg" alt="">
                            <h3 class="text-center">12th South Asian Games 2016</h3>
                        </div>
                        <div class="association">
                            <img src="../assets/images/associates/Tawang Festival 2016.jpg" alt="">
                            <h3 class="text-center">Tawang Festival 2016</h3>
                        </div>
                        <div class="association">
                            <img src="../assets/images/associates/Tibet Festival 2015.jpg" alt="">
                            <h3 class="text-center">Tibet Festival 2014</h3>
                        </div> 
                        <div class="association">
                            <img src="../assets/images/associates/World Tourism Day 2016.jpg" alt="">
                            <h3 class="text-center">World Tourism Day 2016</h3>
                        </div> 
                        <div class="association">
                            <img src="../assets/images/associates/Ziro Festival of Music.jpg" alt="">
                            <h3 class="text-center">Ziro Festival of Music 2015</h3>
                        </div> 
                    </carousel>
                </div>
            </div>
        </div>
      
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
    components:{
        carousel
    }
}
</script>


<style scoped>
   .owl-item{
       width: 4rem !important;
   }
    .association{
        width: 500px;
    }
    .association img{
        height: 100%;
        width: 100%;
        object-position: center;
        object-fit: contain;
    }
    @media (max-width: 700px){
        .owl-item{
       width: 2rem !important;
   }
        .association{
        width: 300px;
    }
    }
</style>